import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddUserToEventAccountMutationVariables = Types.Exact<{
  event_account_id: Types.Scalars['ID'];
  input: Types.UpdateEventAccountUserInput;
}>;


export type AddUserToEventAccountMutation = { __typename?: 'Mutation', addUserToEventAccount: { __typename?: 'EventAccount', id: string, name?: string | null, description?: string | null, email?: string | null, users: Array<{ __typename?: 'EventAccountUser', id: string, name: string, can_do_order_fulfillments: boolean, password: string }>, participating_in_events?: Array<{ __typename?: 'Event', id: string, name?: string | null, image_url?: string | null, start_date?: string | null, end_date?: string | null }> | null, item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string }> | null, authorized_signers: Array<{ __typename?: 'AuthorizedSigner', id: string, name: string }> } };


export const AddUserToEventAccountDocument = gql`
    mutation AddUserToEventAccount($event_account_id: ID!, $input: UpdateEventAccountUserInput!) {
  addUserToEventAccount(event_account_id: $event_account_id, input: $input) {
    id
    name
    description
    email
    users {
      id
      name
      can_do_order_fulfillments
      password
    }
    participating_in_events {
      id
      name
      image_url
      start_date
      end_date
    }
    item_locations {
      id
      name
    }
    authorized_signers {
      id
      name
    }
  }
}
    `;
export type AddUserToEventAccountMutationFn = Apollo.MutationFunction<AddUserToEventAccountMutation, AddUserToEventAccountMutationVariables>;

/**
 * __useAddUserToEventAccountMutation__
 *
 * To run a mutation, you first call `useAddUserToEventAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToEventAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToEventAccountMutation, { data, loading, error }] = useAddUserToEventAccountMutation({
 *   variables: {
 *      event_account_id: // value for 'event_account_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserToEventAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToEventAccountMutation, AddUserToEventAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToEventAccountMutation, AddUserToEventAccountMutationVariables>(AddUserToEventAccountDocument, options);
      }
export type AddUserToEventAccountMutationHookResult = ReturnType<typeof useAddUserToEventAccountMutation>;
export type AddUserToEventAccountMutationResult = Apollo.MutationResult<AddUserToEventAccountMutation>;
export type AddUserToEventAccountMutationOptions = Apollo.BaseMutationOptions<AddUserToEventAccountMutation, AddUserToEventAccountMutationVariables>;